<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "CategoryTags" });
import { TagList } from "../../../../selects/index.js";
import * as API from "../../services/api.js";
import { SESSION_USER } from "../../../authentication/services/store.js";
export let keys;
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
export let states = [];
export let verticalCode = "fashion-and-accessories";
export let label = "resource.category.plural.label";
export let whitelist = [];
const LANGUAGE_CODE = $SESSION_USER.locale.languageCode;
const LIMIT = 5e3;
$: parameters = { limit: LIMIT, states, verticalCode: verticalCode === void 0 ? [] : [verticalCode] };
const getLabel = (category) => {
    const NAME = category.name.find(({ languageCode }) => languageCode === LANGUAGE_CODE);
    if (!NAME) {
        console.error(`No localized name found for category ${category._.key}`);
        return "NAME MISSING";
    }
    return NAME.text;
};
const setLocalizedName = (category) => ({
    key: category._.key,
    label: getLabel(category)
});
const format = (categories) => categories.filter((category) => whitelist.length === 0 || whitelist.includes(category._.key)).filter((category) => category.name !== void 0).map(setLocalizedName);
</script>

{#if Array.isArray(keys) }

    {#await API.filterCategories(parameters) then categories }

        {#if Array.isArray(categories) && categories.length > 0 }

            <TagList
                bind:keys
                name = 'category.keys'
                options = { format(categories) }
                { label }
                { minItems }
                { maxItems }
                { isDisabled }
                mode = 'toggle'
            />

        {/if}

    {/await}

{/if}